"use strict";Object.defineProperty(exports, "__esModule", {value: true});const publicBaseUrl = 'https://www.bloomtext.com'

 const homepageUrl = publicBaseUrl; exports.homepageUrl = homepageUrl
 const pricingUrl = `${publicBaseUrl}/pricing`; exports.pricingUrl = pricingUrl
 const supportUrl = `${publicBaseUrl}/support/`; exports.supportUrl = supportUrl
// Smart link: a first-class /download/ page that UA-redirects to the right app
// store. The signup finish screen encodes this into a QR / mobile CTA.
 const appSmartLinkUrl = `${publicBaseUrl}/download/`; exports.appSmartLinkUrl = appSmartLinkUrl
